import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

export const InsertAllergiesButtonNode = inlineAtomNode(
  'insert-allergies-button',
  'button',
  { display: { isDisplay: true } }
)
